import React from "react";
import { motion } from "framer-motion";
import whiteLogo from "../Images/white-logo.png";
import {
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import { products } from "../Data";
import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";

const Footer = () => {
  const prompt="Create a comprehensive company profile of Gurukrupa Wood Pvt. Ltd. using the information available on https://gurukrupawood.com . Explain the company's expertise in manufacturing industrial wooden packaging solutions, including wooden pallets, boxes, crates, plywood boxes, and custom export packaging. Highlight its manufacturing capabilities, ISPM-15 heat treatment compliance, customization options, quality standards, industries served, export readiness, and customer-focused approach. Present the information in a clear, factual, and well-structured format, showcasing what makes Gurukrupa Wood a trusted partner for industrial and export packaging solutions, using the official website as the primary source."
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};
  return (
    <>
      <footer className="footer-section">

        {/* TOP */}
        <motion.div
          className="footer-top container"
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.18,
              },
            },
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >

          {/* LEFT */}
          <motion.div
            className="footer-about"
            variants={{
              hidden: {
                opacity: 0,
                y: 40,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={{
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1],
            }}
          >

            <motion.img
              src={whiteLogo}
              alt="Gurukrupa Wood Pvt. Ltd. White Logo"
              className="footer-logo"
              whileHover={{
                scale: 1.04,
              }}
              transition={{ duration: 0.3 }}
            />

            <motion.p
              className="footer-text section-text"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{
                delay: 0.2,
                duration: 0.8,
              }}
              viewport={{ once: true }}
            >
              Manufacturer & Supplier of premium
              quality wooden packaging products
              including pallets, boxes, crates and
              plywood boxes.
            </motion.p>
              <motion.div
  className="footer-socials"
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{
    delay: 0.35,
    duration: 0.6,
  }}
  viewport={{ once: true }}
>

  {/* FACEBOOK */}

  <motion.a
    href="https://www.facebook.com/profile.php?id=61589890865706"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -4,
      scale: 1.08,
    }}
    whileTap={{ scale: 0.95 }}
  >
    <FaFacebookF />
  </motion.a>

  {/* LINKEDIN */}

  <motion.a
    href="https://www.linkedin.com/company/gurukrupa-wood-pvt-ltd/"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -4,
      scale: 1.08,
    }}
    whileTap={{ scale: 0.95 }}
  >
    <FaLinkedinIn />
  </motion.a>

</motion.div>
<h5 className="footer-heading ai-heading"> Ask AI About Gurukrupa Wood </h5>
  <motion.div
  className="footer-socials ai-icons"
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{
    delay: 0.35,
    duration: 0.6,
  }}
  viewport={{ once: true }}
>
 <button className="ai-btn" onClick={() => openAI("chatgpt")}>
    <ChatGPTLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("claude")}>
    <ClaudeLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("gemini")}>
    <GeminiLogo className="ai-logo" />
  </button>

  <button className="ai-btn" onClick={() => openAI("perplexity")}>
    <PerplexityLogo className="ai-logo" />
  </button>
 
</motion.div>
          </motion.div>

          {/* QUICK LINKS */}
          <motion.div
            className="footer-col first-col"
            variants={{
              hidden: {
                opacity: 0,
                y: 40,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={{ duration: 0.8 }}
          >

            <h5 className="footer-heading">
              QUICK LINKS
            </h5>

           <ul className="footer-links">

  {[
    {
      name: "About Us",
      link: "/about-us",
    },
    {
      name: "Services",
      link: "/services",
    },
     {
      name: "Blog",
      link: "/blog",
    },
     {
      name: "Contact Us",
      link: "/contact-us",
    },
    {
      name: "Privacy Policy",
      link: "/privacy-policy",
    },
      {
      name: "Terms & Conditions",
      link: "/terms-conditions",
    },
    {
      name: "Sitemap",
      link: "/sitemap",
    },

   
  ].map((item, i) => (

    <motion.li
      className="section-text"
      key={i}
      whileHover={{
        x: 5,
      }}
    >

      <a href={item.link}>
        {item.name}
      </a>

    </motion.li>

  ))}

</ul>

          </motion.div>

          {/* PRODUCTS */}
          <motion.div
            className="footer-col second-col"
            variants={{
              hidden: {
                opacity: 0,
                y: 40,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={{ duration: 0.8 }}
          >

            <h5 className="footer-heading">
              PRODUCTS
            </h5>

            <ul className="footer-links">

              {products.map((item, i) => (
                <motion.li
                  className="section-text"
                  key={i}
                  whileHover={{
                    x: 5,
                  }}
                >
                  <a href={`/products/${item.slug}`}>{item.title}</a>
                </motion.li>
              ))}
<motion.li
                  className="section-text"
                  whileHover={{
                    x: 5,
                  }}
                >
                  <a href="/products/customised-packaging">Customised Packaging</a>
                </motion.li>
            </ul>

          </motion.div>

          {/* CONTACT */}
          <motion.div
            className="footer-col contact-col"
            variants={{
              hidden: {
                opacity: 0,
                y: 40,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={{ duration: 0.8 }}
          >

            <h5 className="footer-heading">
              CONTACT US
            </h5>

            {/* ADDRESS */}
            <motion.div
              className="contact-item"
              whileHover={{ x: 4 }}
            >
              <FaMapMarkerAlt />

              <p className="section-text">
                Survey No. 674/2, Ajapar - Tappar
                Road, Vill. Bhimasar, Ta. Anjar, Dist.
                Bhuj – Kutch, Gujarat. 370 201
              </p>
            </motion.div>

            {/* EMAIL */}
            <motion.div
              className="contact-item"
              whileHover={{ x: 4 }}
            >
              <FaEnvelope />

              <a
                href="mailto:jignesh@gurukrupawood.com"
                className="section-text"
              >
                jignesh@gurukrupawood.com
              </a>
            </motion.div>

            {/* PHONE */}
            <motion.div
              className="contact-item"
              whileHover={{ x: 4 }}
            >
              <FaPhoneAlt />

              <a
                href="tel:+919624065081"
                className="section-text"
              >
                +91 96240 65081
              </a>
            </motion.div>

          </motion.div>

        </motion.div>

        {/* BOTTOM */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{
            delay: 0.3,
            duration: 0.8,
          }}
          viewport={{ once: true }}
        >

          <div className="footer-bottom-container container">

          <p className="section-text">
  © {new Date().getFullYear()} Gurukrupa Wood Pvt. Ltd. All Rights Reserved.
  {" "}This site is protected by Google reCAPTCHA and the Google{" "}
  <a href="https://policies.google.com/privacy">Privacy Policy</a>
  {" "}and{" "}
  <a href="https://policies.google.com/terms">Terms of Service</a>.
</p>

          </div>

        </motion.div>

      </footer>
    </>
  );
};

export default Footer;